import { ReactElement } from 'react';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import MuiDialogContent from '@mui/material/DialogContent';

interface IProps {
  children: ReactElement;
  open: boolean;
  preventOutsideClick?: boolean;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
  containerClassName?: string;
  fullWidth?: boolean;
  className?: string;
  onClose?: () => void;
}

const Modal = ({
  children,
  open,
  preventOutsideClick,
  maxWidth = 'sm',
  containerClassName = '',
  fullWidth = false,
  className = '',
  onClose,
}: IProps): ReactElement => (
  <Dialog
    open={open}
    maxWidth={maxWidth}
    fullWidth={fullWidth}
    className={containerClassName}
    slotProps={{ paper: { className } }}
    onClose={(_, reason): DialogProps['onClose'] => {
      if (reason && preventOutsideClick && reason === 'backdropClick') return;
      onClose?.();
    }}
  >
    <MuiDialogContent>{children}</MuiDialogContent>
  </Dialog>
);

export default Modal;
